import {useState} from "react"
import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react"
import {IconTableExport} from "@tabler/icons-react"
import {exportData} from "@/utils/api/functions/export-data"
import {useUser} from "@/contexts/UserContextProvider"

const ExportDataModal = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const {
    isOpen: isExportModalOpen,
    onOpen: onExportModalOpen,
    onOpenChange: onExportModalOpenChange,
  } = useDisclosure()

  const {orgId} = useUser()

  async function exportOrganizationData() {
    setIsLoading(true)
    if (!orgId) {
      console.error("No orgId found")
      setIsLoading(false)
      return
    }
    await exportData({orgId: orgId})
    setIsLoading(false)
  }

  return (
    <>
      <Button
        onPress={onExportModalOpen}
        isIconOnly
        isLoading={isLoading}
        isDisabled={isLoading}
      >
        <div className="flex flex-row items-center gap-2">
          <IconTableExport className="h-4 w-4" />
        </div>
      </Button>

      <Modal isOpen={isExportModalOpen} onOpenChange={onExportModalOpenChange}>
        <ModalContent>
          <ModalHeader>Export Organization Data</ModalHeader>
          <ModalBody>
            Are you sure you want to export all your organization data? This
            might take a few minutes depending on the amount of data in your
            organization. The download will start automatically, please don't
            refresh the page.
          </ModalBody>
          <ModalFooter>
            <Button variant="light" onPress={onExportModalOpenChange}>
              Cancel
            </Button>
            <Button
              color="primary"
              onPress={() => {
                exportOrganizationData()
                onExportModalOpenChange()
              }}
            >
              Export
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ExportDataModal
